import React, { useState } from 'react'
import Header from '../components/Header'
import Oursuccess from '../components/Oursuccess'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/pagination';
import { useMediaQuery } from 'react-responsive';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation, Scrollbar, A11y } from 'swiper/modules';
import Demo from '../components/Navbar';


const Education = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const openModal = () => {
        document.body.classList.add('modal-open'); // Prevent background scroll
        setIsModalOpen(true);
    };

    const closeModal = () => {
        document.body.classList.remove('modal-open'); // Allow background scroll
        setIsModalOpen(false);
    };

    const openModal1 = () => {
        document.body.classList.add('modal-open'); // Prevent background scroll
        setIsModalOpen1(true);
    };

    const closeModal1 = () => {
        document.body.classList.remove('modal-open'); // Allow background scroll
        setIsModalOpen1(false);
    };
    const services = [
        {
            title: 'Optimized Digital Infrastructure',
            icon: '/cyber11.png',
            desc: "Revamping legacy IT systems with scalable, high-performance infrastructure to support future business demands."
        },
        {
            title: 'Integrated Security & Managed Services',
            icon: '/cyber10.png',
            desc: "Next-gen Identity & Access Services to secure your digital transformation journey across all platforms and environments."
        },
        {
            title: 'Resilient Network Infrastructure',
            icon: '/cyber12.png',
            desc: "Enhancing network security posture for enterprises by mitigating vulnerabilities and fortifying defenses against cyber risks."
        },
        {
            title: 'Advanced Backup & Disaster Recovery',
            icon: '/cyber13.png',
            desc: "Comprehensive cloud and data center backup solutions designed to ensure business continuity during attacks or failures."
        },
        {
            title: 'Comprehensive IAM Solutions',
            icon: '/cyber14.png',
            desc: "Next-gen Identity & Access Services to secure your digital transformation with robust authentication and access control mechanisms."
        },
        {
            title: 'Cloud Security Integration Services',
            icon: '/cyber16.png',
            desc: "Seamless and scalable cloud security operations management delivered in an efficient, cost-effective as-a-service model."
        },
        {
            title: 'AI & Emerging Tech Advisory Services',
            icon: '/cyber17.png',
            desc: "Spotcomm’s Artificial Intelligence, Open Source, 5G, and other advanced technologies to accelerate business transformation."
        },
        {
            title: 'Data Privacy & Compliance Management',
            icon: '/cyber15.png',
            desc: "Tailored data privacy and OT/IoT security solutions to safeguard sensitive information and ensure compliance with global regulations."
        },
    ];


    const Desktop = ({ children }) => {
        const isDesktop = useMediaQuery({ minWidth: 992 })
        return isDesktop ? children : null
    }
    const Tablet = ({ children }) => {
        const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
        return isTablet ? children : null
    }
    const Mobile = ({ children }) => {
        const isMobile = useMediaQuery({ minWidth: 20, maxWidth: 991 })
        return isMobile ? children : null
    }
    const Default = ({ children }) => {
        const isNotMobile = useMediaQuery({ minWidth: 768 })
        return isNotMobile ? children : null
    }
    return (
        <div>
            <Header />
            <section id="heros" className="heros1 section dark-background">

                <img src='/education.png' className='w-100 ' />

                <div className="container text-start">
                    <div className="row justify-content-start">
                        <div className="col-lg-12">
                            <h2 className='profh2'>Education <br />
                                Industry   </h2>

                            {/* <img src="/button.svg" alt="play icon" className='mt-4' style={{ width: "80px", height: "80px", left: "40%" }} /> */}
                        </div>
                    </div>
                </div>

            </section>

            <br />
            <div className='container'>
                <div className=' row  ' id='cyber'>
                    <div className='col-lg-6   ' data-aos="fade-right" data-aos-delay="100">

                        <h2 className='h2 fw-bold text-start'>Our Passion for  <span className='' style={{ color: "#7F3E98" }}>Education  <br />
                        </span>and<span className='' style={{ color: "#7F3E98" }} > Awareness </span> </h2><br />
                        <p className=' ' >Driven by a deep passion for education and awareness, we empower minds and inspire change.</p>
                        <br />   <button className="btns21 
                 
                         d-block " onClick={openModal1}>Read More</button>
                    </div>

                    <div className='col-lg-6 ' data-aos="fade-up" data-aos-delay="100"><br />
                        <img src='/education3.png' className='w-75 mx-auto d-flex justify-content-center' />
                    </div>
                    <br /> <br />
                </div>
            </div>
            {isModalOpen1 && (
                <div className="modal" style={{ display: 'flex', alignItems: "center" }}>
                    <div className="modal-content bg-light   ">
                        <span className="close " style={{ color: "#7F3E98" }} onClick={closeModal1}>&times;</span>
                        <div className="modal-body">
                            <p className='' style={{ fontSize: "15px" }}>
                                Educational institutions are experiencing significant change and since Covid-19, the world has moved from in-institution education to remote live session based setup. From preschool to high school, and universities to technical courses, educational institutions have navigated across their operations and service delivery. Hybrid and flexible learning models are the new way to go for students to learn, and also how faculty support new delivery mechanisms.
                                Industry leaders are challenged to improve service efficiency and student outcomes without compromising the overall experience. Technology can help drive these imperatives and create a future where institutions deliver value in education, research and experience. But realizing this future requires a partner with the experience and expertise to accelerate digital transformation in education, enabling all stakeholders to achieve their desired outcomes.

                                Spotcomm helps educational institutions around the world manage their digital transformation journey by providing solutions that:

                                Providing Seamless internet experience for teachers and students.
                                Effectively manage the student lifecycle experience and expectations
                                Improve productivity by enhancing the onsite digital infrastructure and WiFi experience
                                Modernize infrastructure and provide critical support, significantly increasing overall effectiveness
                                Leverage data to derive actionable insights and aid in decision making
                                Drive innovation to improve learning and teaching outcomes

                                Spotcomm not only helps organizations network design, but also helps in customizing, implementing, managing and improving a number of systems, from the Student Access Control (SAC), learning management system and CRM to workflow management systems, inhouse servers and IT desktop systems deployed in the labs. These diverse capabilities reflect the full range of functions affected by digital transformation in education.

                                Through Spotcomm’s network consulting expertise, educational institutions can build sustainable digital systems that increase the network capability of student enrollment, improve student/employee satisfaction, drive favorable outcomes for institutions and optimize operations for them.



                            </p>
                        </div>
                    </div>
                </div>
            )}
            <br />
            <section id="heros" className="cyber3 section dark-background">

                <img src="/education1.png" alt="" />

                <div className="container">
                    <div className="row ">
                        <div className="col-lg-9">
                            <h2 className='text-start'>The Future of Network Solutions in
                                Educational Institutions

                            </h2><br />
                            <p className='w-100'>Spotcomm’s Managed Network Services offer educational institutions the tools they need to thrive in a technology-driven environment. By enhancing connectivity, security, and support, these services not only improve operational efficiency but also foster a more effective learning experience for students and educators alike. Investing in managed network solutions can significantly contribute to the long-term success of educational institutions, empowering them to focus on their core mission of education while leveraging technology to its fullest potential.
                            </p><br />
                            <button className="service-btn" onClick={openModal}>Read More</button>
                        </div>
                    </div>
                </div>
            </section>

            {isModalOpen && (
                <div className="modal" style={{ display: 'flex', alignItems: "center" }}>
                    <div className="modal-content bg-light  para  ">
                        <span className="close " style={{ color: "#7F3E98" }} onClick={closeModal}>&times;</span>
                        <div className="modal-body">


                            <p style={{ fontSize: "11.5px" }}>
                                At SpotComm, we understand that the future of education is closely tied to the evolution of network technology. As schools, colleges, and universities increasingly adopt digital learning tools, the demand for high-performance, secure, and adaptable network solutions has never been greater. Our vision is to provide educational institutions with cutting-edge network infrastructures that not only support today’s needs but also prepare them for tomorrow's challenges.

                                We offer tailored solutions that enable seamless connectivity across campuses, empowering students and faculty to collaborate, access resources, and engage with digital content anytime, anywhere. Our solutions include high-speed, scalable networks, advanced Wi-Fi technology, and cloud-based systems that ensure fast and reliable access to learning platforms, online assessments, and research resources.

                                Security is a top priority. With the rise of cyber threats targeting educational institutions, our robust security protocols protect sensitive data, secure communications, and safeguard the privacy of students and staff. We also leverage AI and machine learning to proactively detect and respond to potential security risks in real-time.

                                Furthermore, our network solutions integrate with emerging technologies such as the Internet of Things (IoT), allowing for smart classrooms and campus-wide systems that enhance the learning experience. From interactive whiteboards and digital textbooks to real-time attendance tracking and energy-efficient campus management, our solutions bring automation and innovation to educational environments.

                                As educational institutions continue to adopt hybrid and remote learning models, SpotComm’s network solutions are designed to support flexible learning environments, ensuring that students and educators can connect from anywhere, with the same level of reliability and performance as they would on-campus.

                                At SpotComm, we believe that the future of education depends on creating connected, secure, and efficient digital ecosystems. With our advanced network solutions, educational institutions can not only keep up with technological advancements but also lead the way in transforming how education is delivered and experienced across the globe.


                            </p>
                        </div>
                    </div>
                </div>
            )}
            {/* <Oursuccess /> */}
            <div className="mosaic" style={{ background: "#E1E0E0" }}>
                <div
                    data-cmp-data-layer='{"block-how-to-reinvent-software-and-platforms":{"@type":"cio-sites/components/rad/mosaic","analytics-module-name":"mosaic-1","analytics-template-zone":"block-how-to-reinvent-software-and-platforms"}}'
                    id="block-how-to-reinvent-software-and-platforms"
                    className="rad-component__title--large-text rad-mosaic rad-mosaic--6-cards1 rad-spacing-vertical-md"
                >
                    <h3 className="rad-mosaic__heading">
                        Our Perspective

                    </h3>
                    <div
                        className="rad-mosaic__grid"
                        data-template-zone="block-how-to-reinvent-software-and-platforms"
                    >
                        {/* vertical with image or stat card */}
                        <button
                            aria-haspopup="dialog"
                            aria-controls="mosaic-card-item0-00190b0d2ff871a2f02591219e405afa0704cb5eff5dbda70377ffd67d516c9f"
                            className="rad-mosaic__card rad-mosaic__image-card rad-mosaic__card--vertical"
                            data-cmp-clickable=""
                            data-analytics-asset-id="card-a1d20d555b" style={{ background: "rgb(34 34 57)", color: "#fff" }}
                            data-analytics-asset-pos={1}
                            data-cmp-data-layer='{"mosaic-card-item0-00190b0d2ff871a2f02591219e405afa0704cb5eff5dbda70377ffd67d516c9f":{"@type":"cio-sites/components/rad/mosaic","xdm:linkURL":"/ae-en/industries/software-platforms","analytics-engagement":"true","analytics-link-type":"engagement","analytics-link-name":"mosaic card clicked","analytics-module-name":"mosaic-card-pagination-1","analytics-template-zone":"block-how-to-reinvent-software-and-platforms"}}'
                            data-analytics-skim-click=""
                        >
                            <div className="rad-mosaic__card-description">
                                <div className="rad-mosaic__card-description-eyebrow fs-2">Revamping the back office to drive your
                                    university's digital transformation
                                    into a modern campus
                                </div>
                                <h4 className="rad-mosaic__card-description-title fs-5 fw-normal text-light">
                                    The need of having a hybrid environment to accellerate progress
                                </h4>
                            </div>
                            <div className="rad-mosaic__image-card-image">
                                <div
                                    data-cmp-is="image"
                                    data-cmp-dmimage=""
                                    data-cmp-src="https://preview1.assetsadobe.com/is/image/accenture/1306372406?ts=1726612011714&wid=625&fit=constrain&dpr=off"
                                    data-asset-id="841c1d8e-12f6-4942-9596-cbae40d8e5cb"
                                    data-cmp-filereference="/content/dam/accenture/final/images/photography/person/general-people/1306372406.jpeg"
                                    id="image-928d66528f"
                                    data-cmp-data-layer='{"radimage-928d66528f":{"@type":"cio-sites/components/rad/radimage","analytics-engagement":"true","analytics-link-type":"engagement","analytics-link-name":"","analytics-module-name":"radimage-2"}}'
                                    data-cmp-hook-image="imageV3"
                                    className="cmp-image
     "
                                    itemScope=""
                                    itemType="http://schema.org/ImageObject"
                                >
                                    <img
                                        src="/education (3).png"
                                        loading="lazy"
                                        className="cmp-image__image"
                                        itemProp="contentUrl"
                                        width={6720}
                                        height={4480}
                                        alt=""
                                    />
                                </div>
                            </div>

                        </button>


                        <div
                            className="rad-mosaic__card rad-mosaic__image-card rad-mosaic__card--vertical"
                            data-analytics-asset-id="card-ccdc36c5c3"
                            data-analytics-asset-pos={3} style={{ background: "#fefefe" }}
                            data-cmp-data-layer='{"mosaic-card-item2-cd1b49480d1159b0f3091ead9a522c995b89ddee95bb37c4a63e966fcc9d7185":{"@type":"cio-sites/components/rad/mosaic","xdm:linkURL":"/ae-en/industries/software-platforms","analytics-engagement":"true","analytics-link-type":"engagement","analytics-link-name":"mosaic card clicked","analytics-module-name":"mosaic-card-pagination-3","analytics-template-zone":"block-how-to-reinvent-software-and-platforms"}}'
                        >
                            <div className="rad-mosaic__card-description">
                                <div className="rad-mosaic__card-description-eyebrow fs-2">
                                    Education's Future is Here: Advancing and Expanding Student Experiences through Digital Transformation
                                </div>
                                <h4 className="rad-mosaic__card-description-title fs-5">
                                    Journey from on-site to remote learning since Covid-19


                                </h4>
                            </div>
                            <div className="rad-mosaic__image-card-image">
                                <div
                                    data-cmp-is="image"
                                    data-cmp-dmimage=""
                                    data-cmp-src="/education (2).png"
                                    data-asset-id="a0f4780f-06bf-48a7-a917-91808fd9bb5a"
                                    data-cmp-filereference="/content/dam/accenture/final/accenture-com/imagery-2/Accenture-afs-index-mosaic-image1.jpg"
                                    id="image-9f04d566f9"
                                    data-cmp-data-layer='{"radimage-9f04d566f9":{"@type":"cio-sites/components/rad/radimage","analytics-engagement":"true","analytics-link-type":"engagement","analytics-link-name":"","analytics-module-name":"radimage-3"}}'
                                    data-cmp-hook-image="imageV3"
                                    className="cmp-image
     "
                                    itemScope=""
                                    itemType="http://schema.org/ImageObject"
                                >
                                    <img
                                        src="/education (2).png"
                                        loading="lazy"
                                        className="cmp-image__image"
                                        itemProp="contentUrl"
                                        width={3840}
                                        height={2160}
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <section className="services-section" >
                <h2 className='text-center'>Our <span className='' style={{ color: "#7F3E98" }}> Solutions </span> </h2>
                <Desktop>

                <div className="row  d-flex  mx-auto justify-content-center ">

                        {services.map((service, index) => (
                            <div className="col-lg-3 ml-5  mt-5" key={index} >
                                <div
                                    className="service-cardsss h-100"
                                    style={{ "--image-url": `url(${service.icon})` }}  // Setting the image URL
                                > <br /> <br />
                                    <div className="service-title cmp-teaser__title-link fs-5">{service.title}</div>
                                    <p className="text-center  educp">{service.desc}</p> <br />
                                    {/* <button className="service-btn">Read More</button> */}
                                </div>
                            </div>
                        ))}
                    </div>

                </Desktop>
                <Mobile>
                    <div className="services-grid row">
                        <Swiper modules={[Navigation, Autoplay]}
                            spaceBetween={50}
                            slidesPerView={1}
                            navigation
                            autoplay={{
                                delay: 1500,
                                disableOnInteraction: false,
                            }}

                            onSwiper={(swiper) => console.log(swiper)}
                            onSlideChange={() => console.log('slide change')}>
                            {services.map((service, index) => (
                                <SwiperSlide key={index}>
                                    <div className="col-lg-3 service mx-auto mt-5">
                                        <div
                                            className="service-card"
                                            style={{
                                                "--image-url": `url(${service.icon})`,
                                                margin: "10px",
                                                padding: "15px",
                                            }}
                                        >

                                            <div className="service-title text-dark"> <br />{service.title}</div>
                                            {/* <button className="service-btn">Read More</button> */}
                                        </div>
                                    </div>

                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </Mobile>
            </section>
            <Demo />
        </div>
    )
}

export default Education